
import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const InstagramSection = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const images = [
    "https://media.istockphoto.com/id/1373275727/photo/worker-picking-tea-leaves-in-tea-plantation.jpg?s=612x612&w=0&k=20&c=YMOjoeat7t2W7YTpkxg0qIi3FB98rzLlnoK1f8_crCI=",
    "https://experiencekerala.in/kerala-tourism-blog/wp-content/uploads/2019/06/1-1.jpg",
    "https://s3.india.com/wp-content/uploads/2024/07/Bamboo-and-Cane-Products.jpg?impolicy=Medium_Widthonly&w=350&h=263",
    "https://www.wayanadgreenfresh.com/cdn/shop/products/pexels-victoria-bowers-10487732_2_2048x.jpg?v=1736393060",
    "https://content.jdmagicbox.com/v2/comp/wayanad/c5/9999p4936.4936.250227053645.a6c5/catalogue/kaitha-tasty-food-panamaram-wayanad-food-product-retailers-oc01rx2lce.jpg",
  ];

  return (
    <div className="py-5">
      <div className="text-center mb-5">
        <h2 className="fw-bold">Shop Instagram</h2>
        <p className="text-muted">Bring home the purity of Wayanad with Vantara’s handcrafted creations!</p>
      </div>
      {!isMobile && (
        <div
          style={{
            display: 'flex',
            gap: '8px', 
            padding: '0 24px',
            maxWidth: '100%',
            margin: '0 auto',
            overflowX: 'hidden',
            boxSizing: 'border-box',
          }}
        >
          {images.map((src, index) => (
            <div
              key={index}
              style={{
                flex: '1 1 calc((100% - 32px) / 5)', 
                minWidth: '0', 
                height: '300px',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                background: '#fff',
              }}
            >
              <img
                src={src}
                alt={`Look ${index + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </div>
          ))}
        </div>
      )}
      {isMobile && (
        <div
          id="instagramCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner px-3">
            <div className="carousel-item active">
              <div className="d-flex justify-content-center gap-2">
                <img
                  src={images[0]}
                  alt="Look 1"
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />
                <img
                  src={images[1]}
                  alt="Look 2"
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />
                <img
                  src={images[2]}
                  alt="Look 3"
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />
              </div>
            </div>
            <div className="carousel-item">
              <div className="d-flex justify-content-center gap-2">
                <img
                  src={images[3]}
                  alt="Look 4"
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />
                <img
                  src={images[4]}
                  alt="Look 5"
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />
                <img
                  src={images[0]}
                  alt="Look 1 again"
                  className="img-fluid rounded-3 shadow-sm"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
          <div className="text-center mt-3">
            <div className="carousel-indicators position-static">
              <button
                type="button"
                data-bs-target="#instagramCarousel"
                data-bs-slide-to="0"
                className="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#instagramCarousel"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
            </div>
          </div>
        </div>
      )}
      <style>{`
        .carousel-indicators [data-bs-target] {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #bbb; 
        }
        .carousel-indicators .active {
          background-color: #333;
        }
      `}</style>
    </div>
  );
};

export default InstagramSection;











// import { useEffect, useState } from "react";

// function InstagramFeed() {
//   const [posts, setPosts] = useState([]);

//   useEffect(() => {
//     const fetchInstagramPosts = async () => {
//       try {
//         const res = await fetch(
//           `https://graph.instagram.com/me/media?fields=id,media_type,media_url,caption,permalink,timestamp&access_token=YOUR_ACCESS_TOKEN`
//         );
//         const data = await res.json();
//         setPosts(data.data || []);
//       } catch (error) {
//         console.error("Error fetching Instagram posts:", error);
//       }
//     };

//     fetchInstagramPosts();
//   }, []);

//   return (
//     <div className="grid grid-cols-3 gap-4 p-4">
//       {posts.map((post) => (
//         <a
//           key={post.id}
//           href={post.permalink}
//           target="_blank"
//           rel="noreferrer"
//           className="block"
//         >
//           {post.media_type === "IMAGE" || post.media_type === "CAROUSEL_ALBUM" ? (
//             <img
//               src={post.media_url}
//               alt={post.caption || "Instagram post"}
//               className="w-full h-auto rounded-lg shadow"
//             />
//           ) : (
//             <video
//               controls
//               src={post.media_url}
//               className="w-full h-auto rounded-lg shadow"
//             />
//           )}
//         </a>
//       ))}
//     </div>
//   );
// }

// export default InstagramFeed;
